/* eslint-disable import/prefer-default-export */
/* eslint-disable prefer-destructuring */
import { ModuleType, OhsModuleCreateBy } from 'global-services/constants/OhsObject';

export class IncidentLookUp {
  type: ModuleType.Incident;

  _id: string;

  tierId: string;

  reference: string;

  overview: string;

  dateOccurred: string;

  timeOccurred: string;

  category: string;

  categoryOther: string;

  location: string;

  createdBy: OhsModuleCreateBy;

  injuredPersonName: string;

  injuredPersonRole: string;

  injuredPersonRoleOther: string;

  constructor(item: any[]) {
    this.type = ModuleType.Incident;
    this._id = item[0];
    this.tierId = item[1];
    this.reference = item[2];
    this.overview = item[3];
    this.dateOccurred = item[4];
    this.timeOccurred = item[5];
    this.category = item[6];
    this.categoryOther = item[7];
    this.location = item[8];
    this.createdBy = item[10];
    this.injuredPersonName = item[11];
    this.injuredPersonRole = item[12];
    this.injuredPersonRoleOther = item[13];
  }
}
